/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.depts', {
            parent: 'board.project-detail',
            url: '/depts',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER', 'ROLE_FINANCE'],
                pageTitle: 'askApp.project.dept.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/depts/depts.html',
                    controller: 'ProjectDeptsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.depts.edit-dept', {
            parent: 'board.project-detail.depts',
            url: '/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.depts', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.depts.new-dept', {
            parent: 'board.project-detail.depts',
            url: '/new/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: entity,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.depts', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.depts.new-dept-project', {
            parent: 'board.project-detail.depts',
            url: '/new',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: null,
                        entityProject: entity,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.depts', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
